export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.entry.afce50167b86d7119709.bundle.worker.js");
}
